import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  return title.includes('torino') || name.includes('torino');
};

const htmlContent = (html) => {
  if (!html) {
    return '—';
  }
  return (
    <div
      style={{ maxWidth: '100%', wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const imageField = (image, label) => {
  const url = image?.url;
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <img
        src={url}
        alt={image.file_name || label}
        style={{ maxWidth: 200, maxHeight: 120, objectFit: 'contain' }}
      />
    </a>
  );
};

const linkField = (url) => {
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      {url}
    </a>
  );
};

const buildLanguageFields = (t, item, lang) => {
  const suffix = lang.toLowerCase();
  const title = item[`title_${suffix}`] || (suffix === 'it' ? item.title : '');
  const description =
    item[`description_${suffix}`] || (suffix === 'it' ? item.description : '');
  const descriptionShort =
    item[`description_short_${suffix}`] ||
    (suffix === 'it' ? item.description_short : '');
  const discount =
    item[`discount_${suffix}`] || (suffix === 'it' ? item.discount : '');

  return [
    { text: `${t('Titolo')} ${lang}`, value: display(title) },
    {
      text: `${t('Descrizione')} ${lang}`,
      value: htmlContent(description),
    },
    {
      text: `${t('Descrizione corta')} ${lang}`,
      value: display(descriptionShort),
    },
    {
      text: `${t('Sconto o promozione')} ${lang}`,
      value: display(discount),
    },
  ];
};

export const getPartnerViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        { text: t('Link'), value: linkField(item.link) },
        {
          text: t('Immagine hero (jpg, png, gif)'),
          value: imageField(item.image, t('Immagine hero')),
        },
        {
          text: t('Immagine miniatura (jpg, png, gif)'),
          value: imageField(item.image_mini, t('Immagine miniatura')),
        },
      ],
    },
    {
      title: `${t('Contenuto')} (IT)`,
      fields: buildLanguageFields(t, item, 'IT'),
    },
    {
      title: `${t('Contenuto')} (EN)`,
      fields: buildLanguageFields(t, item, 'EN'),
    },
  ];

  if (isTorinoCenter(item)) {
    sections.push({
      title: `${t('Contenuto')} (FR)`,
      fields: buildLanguageFields(t, item, 'FR'),
    });
  }

  return sections;
};
